import { render, staticRenderFns } from "./stuAdvanceRank.vue?vue&type=template&id=baf5eb86"
import script from "./stuAdvanceRank.vue?vue&type=script&lang=js"
export * from "./stuAdvanceRank.vue?vue&type=script&lang=js"
import style0 from "./stuAdvanceRank.vue?vue&type=style&index=0&id=baf5eb86&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports